// extracted by mini-css-extract-plugin
export default {"kbaAlertBanner":"uV2iHCGdlBpPeGRxxiu3"};